import React, { useEffect, useState, useRef } from 'react'
import WidgetHeader from '../../../../components/Widget/Header';
import {useOpeningHoursDiff} from '@arnsbogroup/react-voicearchive/hooks';
import HandoverDetails from "containers/HandoverPage/components/HandoverDetails";
import { FormattedRelativeTime, useIntl } from 'react-intl'
import { selectUnit } from '@formatjs/intl-utils'
import { useHistory } from 'react-router-dom'

const HandoversWidget = ({widget}) => {
  const mounted = useRef(false);
  const history = useHistory()
  
  const [handovers, setHandovers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [title, setTitle] = useState('');
  const [selectedHandoverId, setSelectedHandoverId] = useState(null)

  const { formatDate, formatTime } = useIntl()

  useEffect(() => {
    mounted.current = true;
    fetch('coordinatordashboard/Handovers')
    .then((response) => response.json())
    .then((data) => {
      if (mounted.current) {
        setHandovers(data.data.handovers);
        setOrders(data.data.orders);
      }
    });

    setTitle(widget.widgetId.replace(/_/g, ' '));

    return () => {
      mounted.current = false;
    };
  }, [])

  const showOrderDetails = (uid) => {
    history.push(`/orders/${uid}`)
  }

  const showHandoverDialog = (uid) => {
    setSelectedHandoverId(uid);
  }

  const timeSince = (input) => {
    let timestamp

    if (typeof input === 'number') {
      timestamp = input * 1000
    } else if (typeof input === 'string') {
      timestamp = new Date(input).getTime()
    } else {
      timestamp = Date.now()
    }

    if (isNaN(timestamp)) {
      console.warn('Invalid date for timeSince:', input)
      return null
    }

    const { value, unit } = selectUnit(timestamp)

    const updatableUnits = ['second', 'minute', 'hour']
    const props = {
      value,
      unit,
      ...(updatableUnits.includes(unit) ? { updateIntervalInSeconds: 60 } : {}),
    }
  
    return <FormattedRelativeTime {...props} />
  }

  const getOrderRows = () => {
    return orders?.map((order) => {
      return (
        <tr
          key={order['uid']}
          title={order['deal_id']}
          onClick={() => showOrderDetails(order['uid'])}
          className="bg-red-50 hover:bg-red-300 cursor-pointer"
        >
          <td className="border-b px-4 py-2 w-4/6 space-x-2">
            <span>D{order['deal_id']} missing PM!</span>
          </td>
          <td
            className="border-b px-4 py-2 w-2/6 text-right"
            title={`${formatDate(order['crdate'] * 1000)} ${formatTime(order['crdate'] * 1000)}`}>
            {timeSince(order['crdate'])}
            <span className="text-xs w-2 inline-block ml-2">
              <i className="block rounded-full w-2 h-2 bg-red-600" title="Has no Project Manager"></i>
            </span>
          </td>
        </tr>
      );
    });
  }

  const getHandoverRows = () => {
    return Object.values(handovers)?.map((handover) => {
      return (
        <tr
          key={handover['uid']}
          title={handover['deal_id']}
          onClick={() => showHandoverDialog(handover['uid'])}
          className="hover:bg-gray-200 cursor-pointer"
        >
          <td className="border-b px-4 py-2 w-4/6 space-x-2">
            { handover['language'] && (
              <img
                  src={`https://hatscripts.github.io/circle-flags/flags/${{'da':'dk', 'de':'de', 'en-GB':'gb'}[handover['language']]}.svg`}
                  className="w-4 inline-block"
              />
            )}
            <span>D{handover['deal_id']}</span>
          </td>

          <td
            className="border-b px-4 py-2 w-2/6 text-right"
            title={handover['created_at']}>
            {timeSince(handover['created_at'])}
          </td>

        </tr>
      );
    });
  }

  const getRows = () => {
    if (
      handovers.length == 0 &&
      orders.length == 0
    ) {
      return (
        <tr key={'none'}>
          <td className="px-3 py-2">No handovers is waiting in backlog.</td>
        </tr>
      )
    }

    return (
      <>
        { getHandoverRows() }
        { getOrderRows() }
      </>
    )
  }

  
  const widget_id = `ID_${widget.widgetId}`;
  return (
    <>
      <div className="bg-white border shadow rounded border-gray-400" id={widget_id}>
        <WidgetHeader widget={widget} widgetTitle={title} />

        <div className="py-2 px-4 flex justify-between items-center text-opacity-50 hover:text-opacity-100">
          <div className="text-xs text-gray-500">
              <div className="text-xs flex items-center space-x-1">
                <div className="inline-block w-4 h-4 rounded-full bg-gray-100 border border-gray-200"></div>
                <span className="text-gray-500">= Prefered handling language</span>
              </div>
          </div>
          <div className="space-x-2 flex">
              <div className="text-xs flex items-center space-x-1">
                <div className="inline-block w-4 h-4 rounded border border-gray-200"></div>
                <span className="text-gray-500">= Backlog</span>
              </div>
          </div>
        </div>

        <div className="border-b py-2 px-3 flex justify-between items-center text-opacity-50 hover:text-opacity-100">
          <table className="w-full table-fixed text-xs border-t">
            <tbody>
            { getRows() }
            </tbody>
          </table>

        </div>
      </div>
      <HandoverDetails handoverId={selectedHandoverId} onClose={() => setSelectedHandoverId(null)}/>
    </>
  );

}

export default HandoversWidget;
